module.exports = "/assets/42d113f88c761b0d092b11a9e911e691.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/F7.png
// module id = 2486
// module chunks = 0